<div class="lum-c-sales-order-ag-table-line-items">
  <div class="d-flex justify-content-end mb-4">
    <div class="stock-ag-table-actions">
      <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
        Actions <i class="flaticon-more ml-2"></i>
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button mat-menu-item (click)="onToggleAssemblyOrderDialog()">
          Create Assemble Order
        </button>
        <button (click)="onCreatePurchaseOrder()" mat-menu-item>
          Create Purchase Order
        </button>
        <button (click)="onToggleTransferOrderDialog()" mat-menu-item>
          Create Transfer Order
        </button>
      </mat-menu>
    </div>
  </div>
  <ag-grid-angular
    class="ag-theme-alpine"
    [columnDefs]="gridOptions.columnDefs"
    [gridOptions]="gridOptions"
    [pagination]="true"
    [domLayout]="'autoHeight'"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
